import { render, staticRenderFns } from "./FbPixel.vue?vue&type=template&id=f7013e4c"
import script from "./FbPixel.vue?vue&type=script&lang=js"
export * from "./FbPixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports